import { render, staticRenderFns } from "./modalRespostaAgravoVida.vue?vue&type=template&id=68e9f6bc"
import script from "./modalRespostaAgravoVida.vue?vue&type=script&lang=js"
export * from "./modalRespostaAgravoVida.vue?vue&type=script&lang=js"
import style0 from "./modalRespostaAgravoVida.vue?vue&type=style&index=0&id=68e9f6bc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports